import { faqItems } from "./utils";
import { useState } from "react";
import ExpandableBox from "@/components/landing-old/ExpandableBox";

const ReferralFAQs = () => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const clickHandler = (idx: number) => {
    setActiveIndex((current) => (current === idx ? -1 : idx));
  };
  return (
    <>
      <div className="justify-start items-end inline-flex mt-4">
        <div className="text-stone-900 text-base font-bold leading-9">Referral FAQs</div>
      </div>
      <div className="relative z-30 w-full mt-4">
        {faqItems.map((faq, idx) => (
          <div key={idx}>
            <ExpandableBox
              question={faq.question}
              answer={faq.answer}
              active={activeIndex === idx}
              clickHandler={() => clickHandler(idx)}
              page={"referral"}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default ReferralFAQs;
